/**
 * RoleGuard — Phase 1
 * Redirects to /user/dashboard if user doesn't have admin role.
 * Must be used inside ProtectedRoute (user is already authenticated).
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function RoleGuard({ role = 'admin', children }) {
  const { user } = useAuth();

  if (user?.role !== role) {
    return <Navigate to="/user/dashboard" replace />;
  }

  return children;
}

export default RoleGuard;
